import { Link, Outlet } from 'react-router-dom';
import { usePageTitle } from '@/shared/lib/use-page-title';
import { Footer } from './footer';
import './service-shell.css';

export function ServiceShell() {
  const { contentRef } = usePageTitle();

  return (
    <div className="service-shell">
      <header className="service-shell__header">
        <span className="service-shell__logo">
          <img src="/images/logo.svg" alt="체인지콘" width="69" height="20" />
        </span>
        <Link to="/information" className="service-shell__info" aria-label="이용안내">
          <svg aria-hidden="true" viewBox="0 0 20 20" width="20" height="20" fill="none">
            <circle cx="10" cy="10" r="8.5" stroke="currentColor" strokeWidth="1.3" />
            <line x1="10" y1="9" x2="10" y2="14" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
            <circle cx="10" cy="6.2" r="0.9" fill="currentColor" />
          </svg>
        </Link>
      </header>
      <div className="service-shell__content" ref={contentRef} tabIndex={-1}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
